module.exports = __webpack_public_path__ + "static/img/logo_samu.2eaaad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_samu.png
// module id = NALD
// module chunks = 4